angular.module('eatself').directive('confirmPopover', function($templateCache, $compile, $timeout) {
	// Runs during compile
	return {
		// name: '',
		// priority: 1,
		// terminal: true,
		// scope: {
		// 	confirmPopover: '&',
		// 	confirmText: '@',
		// 	confirmTemplate: '@',
		// }, // {} = isolate, true = child, false/undefined = no change
		// controller: function($scope, $element, $attrs, $transclude) {},
		// require: 'ngModel', // Array = multiple requires, ? = optional, ^ = check parent elements
		// restrict: 'A', // E = Element, A = Attribute, C = Class, M = Comment
		// template: '',
		// templateUrl: '',
		// replace: true,
		// transclude: true,
		// compile: function(tElement, tAttrs, function transclude(function(scope, cloneLinkingFn){ return function linking(scope, elm, attrs){}})),
		link: function($scope, iElm, iAttrs, controller) {
			var template;
			if (iAttrs.confirmTemplate) {
				template = $templateCache.get(iAttrs.confirmTemplate)
			} else {
				var title = iAttrs.confirmText || 'Sûr ?'
				var action = iAttrs.confirmPopover
				template = '<button class="btn btn-danger" ng-click="' + action + '">' + title + '</button>'
			}
			var isInside = function(target, parent) {
				return $(target).closest(parent).length;
			}
			var createPopover = function() {
				var content = $compile($(template))($scope);
				iElm.on('shown.bs.popover',function() {
					$(document).one('click',function(event) {
						if (!isInside(event.target, iElm)) {
							iElm.click();
						}
					})
				})
				iElm.popover({
					content: content,
					html: true,
					// container: 'body',
					trigger: 'click',
				})
			}
			createPopover();
			iElm.bind("destroyed",function() {
				// iElm.popover('destroy')
			})
		}
	};
})
.run(function() {
	// angular.element.event.special.destroyed = {
	//     remove: function(o) {
	//       if (o.handler) {
	//         o.handler()
	//       }
	//     }
	//   }
});
